function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(21.3333,0,0,21.3333,0,10.6667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,16C4,16.88 4.39,17.67 5,18.22L5,20C5,20.55 5.45,21 6,21L7,21C7.55,21 8,20.55 8,20L8,19L16,19L16,20C16,20.55 16.45,21 17,21L18,21C18.55,21 19,20.55 19,20L19,18.22C19.61,17.67 20,16.88 20,16L20,6C20,2.5 16.42,2 12,2C7.58,2 4,2.5 4,6L4,16Z",
    style: {
      fill: "rgb(249,249,249)",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(21.3333,0,0,21.3333,0,10.6667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,16C4,16.88 4.39,17.67 5,18.22L5,20C5,20.55 5.45,21 6,21L7,21C7.55,21 8,20.55 8,20L8,19L16,19L16,20C16,20.55 16.45,21 17,21L18,21C18.55,21 19,20.55 19,20L19,18.22C19.61,17.67 20,16.88 20,16L20,6C20,2.5 16.42,2 12,2C7.58,2 4,2.5 4,6L4,16ZM7.5,17C6.67,17 6,16.33 6,15.5C6,14.67 6.67,14 7.5,14C8.33,14 9,14.67 9,15.5C9,16.33 8.33,17 7.5,17ZM16.5,17C15.67,17 15,16.33 15,15.5C15,14.67 15.67,14 16.5,14C17.33,14 18,14.67 18,15.5C18,16.33 17.33,17 16.5,17ZM18,11L6,11L6,6L18,6L18,11Z",
    style: {
      fill: "rgb(128,0,128)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(21.3333,0,0,21.3333,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.609,
    y: 12.157,
    width: 1.364,
    height: 1.378,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.442,
    y: 12.157,
    width: 1.364,
    height: 1.378,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.246,
    y: 12.157,
    width: 1.364,
    height: 1.378,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.157,
    cy: 14.613,
    r: 0.741,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.092,
    cy: 14.613,
    r: 0.741,
    style: {
      fill: "white"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4974eab4b08d557096f33bcae8f2bc5c.svg";
export { ForwardRef as ReactComponent };